// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-panel[data-v-1464d8ea] {\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n.settings-panel > .panel-heading[data-v-1464d8ea] {\n  border-bottom: 1px solid #e4eaec;\n}", ""]);
// Exports
module.exports = exports;
